// 택배 API v1.0 문서 데이터
import { default_header, default_header_example } from '../defaultData';

const getV10APIs = (userInfo) => {
  return [
    {
      title: '택배사 등록',
      url: '/doc/택배사 등록',
      data: [
        {
          version: 'v1.0',
          url: '/carriers',
          method: 'POST',
          desc: (
            <div>
              택배사에서 발급받은 계정 정보를 PLAYAUTO 솔루션에 등록합니다.
              <div className='description' style={{ padding: '12px 0' }}>
                택배사와 직접 계약하여 발급받은 거래처 ID 와 인증코드가 필요합니다.
              </div>
            </div>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'carrier_code',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  택배사 코드
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>G005</code>
                          </strong>
                        </td>
                        <td>
                          <strong>블랙캣(T-CAT)</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'carrier_id',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  택배사 거래처 ID
                  <div className='description'>
                    (택배사에서 발급받은 거래처 ID)
                  </div>
                </div>
              ),
            },
            {
              title: 'auth_code',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  택배사 인증코드
                  <div className='description'>
                    (택배사에서 발급받은 인증코드)
                  </div>
                </div>
              ),
            },
          ],
          body_example: {
            carrier_code: 'G005',
            carrier_id: 'playauto01',
            auth_code: 'AUTH0123456789',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '',
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: '결과',
              indent: 1,
            },
            {
              title: 'messages',
              required: 'O',
              type: 'Array',
              desc: '처리 결과 메세지',
              indent: 1,
            },
          ],
          response_example: {
            results: [
              {
                status: 'success',
                messages: ['택배사 계정이 등록되었습니다.'],
              },
            ],
          },
          error_example: {
            error_code: 'e2305',
            messages: '이미 등록되어 있는 택배사 계정입니다.',
          },
        },
      ],
    },
  ];
};

export default getV10APIs;
